import { render, staticRenderFns } from "./pint7x4positive.vue?vue&type=template&id=3a7edcf5&scoped=true&"
import script from "./pint7x4positive.vue?vue&type=script&lang=js&"
export * from "./pint7x4positive.vue?vue&type=script&lang=js&"
import style0 from "./pint7x4positive.vue?vue&type=style&index=0&id=3a7edcf5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7edcf5",
  null
  
)

export default component.exports